import { Button } from "@clockwise/design-system";
import classNames from "classnames";
import React from "react";

interface Props {
  shouldShowSecondary: boolean;
  primaryLabel: string;
  secondaryLabel: string;
  onClickPrimary: () => void;
  onClickSecondary: () => void;
  disabled?: boolean;
  disablePrimaryOnly?: boolean;
}
export const ButtonGroup = ({
  shouldShowSecondary,
  primaryLabel,
  secondaryLabel,
  onClickPrimary,
  onClickSecondary,
  disabled = false,
  disablePrimaryOnly = false,
}: Props) => {
  return (
    <div className="cw-bg-default cw-bg-opacity-70 cw-absolute cw-bottom-0 cw-w-full cw-flex cw-flex-col cw-items-center  cw-z-[10]">
      <div
        className={classNames(
          "cw-flex cw-items-center cw-justify-center cw-w-full cw-pb-4 cw-mt-2 ",
          "md:cw-w-[500px]",
          {
            "md:cw-w-[500px]": shouldShowSecondary,
            "md:cw-w-[250px]": !shouldShowSecondary,
          },
        )}
      >
        {shouldShowSecondary && (
          <div className="cw-px-2 cw-w-full">
            <Button
              sentiment="neutral"
              variant="outlined"
              size="large"
              fullWidth
              onClick={onClickSecondary}
              disabled={disabled}
            >
              {secondaryLabel}
            </Button>
          </div>
        )}
        <div className="cw-px-2 cw-w-full">
          <Button
            sentiment="positive"
            size="large"
            fullWidth
            onClick={onClickPrimary}
            disabled={disabled || disablePrimaryOnly}
          >
            {primaryLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
